function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.237 24c-.3 0-.5 0-.7-.2-.199-.2-.399-.4-.499-.7L.04 17.907c-.1-.3 0-.6.2-.8L9.73 2.222C11.229-.077 14.326-.677 16.524.822c2.297 1.499 2.897 4.596 1.398 6.794l-9.59 14.786c-.2.3-.4.4-.7.499L2.237 24zm0-6.094l.7 3.696 3.796-.799 9.39-14.386c.8-1.3.5-2.898-.698-3.797-1.2-.799-2.898-.5-3.797.8l-9.39 14.486z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24"
  }, props), _ref);
};

export default SvgComponent;